
const context = require.context('./', false, /\.(vue)$/)
const components = []
context.keys().forEach((filename) => {
    const item = context(filename).default
    components.push(item)
})
export default components